import { formatDate } from './formatDate';

export const formatVersionLabel = (id, versions) => {
  const versionIndex = versions.findIndex((version) => version.id === id);
  const versionNumber = versions.length - versionIndex;
  const version = versions[versionIndex];

  const versionLabel = `Version ${versionNumber} (${formatDate(version.created_at)})`;

  return versionLabel;
};

export const getVersionNumber = (id, versions) => {
  const versionIndex = versions.findIndex((version) => version.id === id);
  const versionNumber = versions.length - versionIndex;

  return versionNumber;
};
